import {
    Directive,
    effect,
    signal,
    TemplateRef,
    ViewContainerRef,
    inject,
} from '@angular/core';

@Directive({
    selector: '[qpxCmdkLoader]',
})
export class QpxCmdkLoader {
    //#region Dependency injection
    private readonly templateRef = inject(TemplateRef<unknown>);
    private readonly viewContainer = inject(ViewContainerRef);
    //#endregion

    //#region State
    private readonly visible = signal(false);
    private readonly hasView = signal(false);
    //#endregion

    //#region Lifecycle hooks
    constructor() {
        effect(() => this.syncView(this.visible()));
    }
    //#endregion

    //#region Public methods
    public show(condition: boolean): void {
        this.visible.set(condition);
    }
    //#endregion

    //#region Private methods
    private syncView(visible: boolean): void {
        if (visible && !this.hasView()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView.set(true);
            return;
        }

        if (!visible && this.hasView()) {
            this.viewContainer.clear();
            this.hasView.set(false);
        }
    }
    //#endregion
}
